import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { getUIPathCurrentConnector } from '../../store/selectors/rpa-uipath-conn.selector';
import {
  getUIPathJobsDataSelector,
  getUIPathQueueitemsDataSelector,
  getUipathErrorSelector
} from '../../store/selectors/rpa-uipath-dashboard.selector';

import {
  getUIPathJobsData,
  getUIPathQueueitemsData,
  resetDashboard,
  UIPathResetErrorHandler
} from '../../store/actions/rpa-uipath-dashboard.actions';

import { TranslateService } from '@ngx-translate/core';

import { BzgTabChangeEvent, BzgToastService } from 'bz-genome-angular';
import { UipathJobDashboardComponent } from '../dashboard-types/uipath-job-dashboard/uipath-job-dashboard.component';
import { UipathQueueitemDashboardComponent } from '../dashboard-types/uipath-queueitem-dashboard/uipath-queueitem-dashboard.component';
import { IAppState } from 'app/IAppState';
import { IDataCharts } from '../../common/models/IDataCharts';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';
@Component({
  selector: 'biz-uipath-dashboard-wrapper',
  templateUrl: './uipath-dashboard-wrapper.component.html',
  styleUrls: ['./uipath-dashboard-wrapper.component.scss']
})

export class UipathDashboardWrapperComponent implements OnInit, OnDestroy {

  tabIndex = 0;
  uiPathConnection$: Observable<IRpaConnectionUiPath>;
  isLoading: boolean;
  uiPathConnectionSubscriber: any;
  dataJobsChart: Observable<IDataCharts>;
  dataQueueitemsChart: Observable<IDataCharts>;
  currentUiPathConnection: IRpaConnectionUiPath;
  isError$: Observable<boolean>;
  isErrorSubscriber: any;

  @Input() public uiPathOriginalConnection: IRpaConnectionUiPath;

  @ViewChild('job', { static: false}) jobComponent: UipathJobDashboardComponent;
  @ViewChild('queueitem', { static: false}) queueitemComponent: UipathQueueitemDashboardComponent;

  constructor(private _translateService: TranslateService, private _store: Store<IAppState>, private _toastService: BzgToastService) {
    this.isLoading = true;
    this.uiPathConnection$ = this._store.pipe(
      select(getUIPathCurrentConnector)
    );
    this.uiPathConnectionSubscriber = this.uiPathConnection$.subscribe(uiPathConnection => this.currentUiPathConnection = uiPathConnection);

    this.dataJobsChart = this._store.pipe(
      select(getUIPathJobsDataSelector)
    ).pipe(
      map((data) => {
        if (data) {
          data.LastYearData.labels = this.translateMonths(data.LastYearData.labels);
          this.jobComponent.refresh();
          return data;
        }
      }));

    this.dataQueueitemsChart = this._store.pipe(
      select(getUIPathQueueitemsDataSelector)
    ).pipe(
      map((data) => {
        if (data) {
          data.LastYearData.labels = this.translateMonths(data.LastYearData.labels);
          this.queueitemComponent.refresh();
          return data;
        }
      }));

    this.isError$ = this._store.pipe(
      select(getUipathErrorSelector)
    );

    this.isErrorSubscriber = this.isError$.subscribe((error) => {
      if (error) {
        this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
          this._toastService.open(
            message,
            {
              type: 'error',
              duration: 0,
              verticalPosition: 'top',
              horizontalPosition: 'right'
            });
        });
        this._store.dispatch(new UIPathResetErrorHandler())
      }
    });
  }
  ngOnInit() {
    this.getDataChartJobs();
  }

  ngOnDestroy() {
    this._store.dispatch(new resetDashboard());

    if (this.uiPathConnectionSubscriber) {
      this.uiPathConnectionSubscriber.unsubscribe();
    }

    if (this.isErrorSubscriber) {
      this.isErrorSubscriber.unsubscribe();
    }
  }

  onTabEvent(event: BzgTabChangeEvent) {
    if (event.index === 0 && this.jobComponent) {
      this.jobComponent.refresh();
    }
    else {
      this.getDataChartQueueItem();
      this.queueitemComponent.refresh();
    }
  }

  private getDataChartQueueItem() {
    let payload = Object.assign({}, this.uiPathOriginalConnection);
    this._store.dispatch(new getUIPathQueueitemsData(payload));
  }

  private getDataChartJobs() {
    let payload = Object.assign({}, this.uiPathOriginalConnection);
    this._store.dispatch(new getUIPathJobsData(payload));
  }

  private translateMonths(monthList: string[]) {
    const newMonthsList: string[] = [];
    if (monthList && monthList.length > 0) {
      monthList.forEach(month => {
        const value = month.split(' ');
        let monthLabel = 'Undefined';
        const year = value[1].substr(2)
        switch (value[0].toUpperCase()) {
          case 'JANUARY':
          case 'ENERO': monthLabel = this.getranslateMonth('january') + '. ' + year;
            break;
          case 'FEBRUARY':
          case 'FEBRERO': monthLabel = this.getranslateMonth('february') + '. ' + year;
            break;
          case 'MARCH':
          case 'MARZO': monthLabel = this.getranslateMonth('march') + '. ' + year;
            break;
          case 'APRIL':
          case 'ABRIL': monthLabel = this.getranslateMonth('april') + '. ' + year;
            break;
          case 'MAY':
          case 'MAYO': monthLabel = this.getranslateMonth('may') + '. ' + year;
            break;
          case 'JUNE':
          case 'JUNIO': monthLabel = this.getranslateMonth('june') + '. ' + year;
            break;
          case 'JULY':
          case 'JULIO': monthLabel = this.getranslateMonth('july') + '. ' + year;
            break;
          case 'AUGUST':
          case 'AGOSTO': monthLabel = this.getranslateMonth('august') + '. ' + year;
            break;
          case 'SEPTEMBER':
          case 'SEPTIEMBRE': monthLabel = this.getranslateMonth('september') + '. ' + year;
            break;
          case 'OCTOBER':
          case 'OCTUBRE': monthLabel = this.getranslateMonth('october') + '. ' + year;
            break;
          case 'NOVEMBER':
          case 'NOVIEMBRE': monthLabel = this.getranslateMonth('november') + '. ' + year;
            break;
          case 'DECEMBER':
          case 'DICIEMBRE': monthLabel = this.getranslateMonth('december') + '. ' + year;
            break;
          default:
            monthLabel = 'Undefined';
        }

        newMonthsList.push(monthLabel);
      });
    }
    return newMonthsList;
  }

  private getranslateMonth(month: string) {
    let newMonth = 'empty';
    this._translateService.get('GLOBAL.MONTHS_OF_YEAR_SHORT.' + month).subscribe((datamonth: string) => {
      newMonth = datamonth;
    });
    return newMonth;
  }
}
